// Import will be used when implementing actions
// import { transactionsApi } from '@/services/api'

// Initial state
const state = {
  transactions: [],
  transactionTypes: [],
  loading: false,
  error: null
}

// Getters
const getters = {
  allTransactions: state => state.transactions,
  transactionTypes: state => state.transactionTypes,
  isLoading: state => state.loading,
  error: state => state.error
}

// Mutations
const mutations = {
  SET_TRANSACTIONS(state, transactions) {
    state.transactions = transactions
  },
  SET_TRANSACTION_TYPES(state, types) {
    state.transactionTypes = types
  },
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

// Actions
const actions = {
  // Will be implemented as needed
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
} 